import { useState } from "react";
import TextArea from "../../../../UI/TextArea";

const HowStuckAffects = ({
  validation,
  backClick,
  saveInputAns,
  getValues,
  clsName,
  removeFromPending,
  removeFromPendingFollowup,
  prevQuestion,
  btnDisable = false,
}) => {
  const [error, setError] = useState("");

  const handleBack = () => {
    if (prevQuestion) {
      prevQuestion("howStuckAffects");
    } else if (backClick) {
      backClick();
    }
  };

  const handleClick = async (e) => {
    const values = getValues();
    const reason = values["stuckAffects"].trim();
    if (reason == "" || reason.length < 3) {
      setError("Please enter");
    } else {
      setError("");

      saveInputAns(e);
      removeFromPending("howStuckAffects");
    }
  };

  return (
    <>
      <div className={`qsSlider slidea5 ${clsName}`}>
        <h2 className="qs-title slide-up-now">
          {" "}
          You've told us you were stuck in your overdraft as a result you didn't
          see a frequent positive balance- how did this affect you?
        </h2>
        <div className="row">
          {/* <ul className="btn-option optinal-items  two-options  slide-up-now">
                <li> */}
          <div className=" option_but ">
            <TextArea
              className="form-control"
              row={4}
              name="stuckAffects"
              placeholder="Type here"
              validation={validation({
                required: true,
              })}
            />
            {error && <span className="error_msg">{error}</span>}
          </div>
          {/* </li> */}
          <div className="col-lg-12 mb-2 mt-2 d-flex justify-content-center align-items-center">
            <button
              className="btn-comm-2    w-100  next7"
              type="button"
              name="howStuckAffects"
              onClick={handleClick}
              data-quest-id={106}
            >
              {/* <span className="btntext"> Continue </span> */}
              Continue
            </button>
          </div>
          <div className="mt-2 mb-4 text-center">
            <div>
              {" "}
              <button
                className={`back-btn mainbckBtn bi bi-chevron-left ${btnDisable ? 'hide' : ''}`}
                type="button"
                onClick={handleBack}
                disabled={btnDisable}
              >
                Back
              </button>{" "}
            </div>
          </div>
          {/* </ul> */}
        </div>
        <p className="mt-1 mb-1">
          (Examples: Anxiety, Stress, Depression, Physical Ailments, Mental
          Health)
        </p>
      </div>
    </>
  );
};

export default HowStuckAffects;
